import { Pipe, PipeTransform } from '@angular/core';
import * as dayjs from 'dayjs';
import sanitizeForUrl from '../../../utils/sanitizeForUrl';
import { HolidayCard } from '../../booking-flow/holiday/holiday-search-page/interfaces/holiday-card';

@Pipe({
  name: 'holidayDetailUrl'
})
export class HolidayDetailUrlPipe implements PipeTransform {
  transform(holiday: HolidayCard, ages: number[] = [35, 35], duration: number = 0): string {

    let productId;
    let dateFrom;
    let dateTo;
    let packetId;
    let topId;
    let title;
    let product;

    if (holiday && holiday.accomodation && holiday.bestSolution) {
      dateFrom = dayjs(holiday.bestSolution.dateFrom).format('DD-MM-YYYY');
      dateTo = dayjs(holiday.bestSolution.dateTo).format('DD-MM-YYYY');
      packetId = holiday.isLive ? holiday.bestSolution.source : holiday.bestSolution.id;
      productId = holiday?.accomodation?.id;
      topId = holiday.tourOperator;
      title = sanitizeForUrl(holiday.title);
      product = 'vacanze';
    }
    if (holiday && holiday.tour && holiday.bestSolution) {
      productId = holiday.tour?.id;
      dateFrom = dayjs(holiday.bestSolution.dateFrom).format('DD-MM-YYYY');
      dateTo = dayjs(holiday.bestSolution.dateTo).format('DD-MM-YYYY');
      packetId = holiday.bestSolution.source;
      productId = holiday?.tour?.id;
      topId = holiday.tourOperator;
      title = sanitizeForUrl(holiday.tour.title);
      product = 'tour';
    }
    return `/${product}/dettaglio/${productId}/${topId}/${packetId}/${holiday.pluginSource}/struttura/${sanitizeForUrl(title)}/dal/${dateFrom}/al/${dateTo}/durata/${duration}/eta/${ages.join(',')}`;
  }
}

